import { render, staticRenderFns } from "./CategoriesMobileItem.vue?vue&type=template&id=4f41a3ee&"
import script from "./CategoriesMobileItem.vue?vue&type=script&lang=js&"
export * from "./CategoriesMobileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports